<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <!--<b-row>-->
        <!--<b-col>-->
          <!--<div v-if="isLoading" class="alert alert-info" role="status">{{$t('alerts.loading')}}...</div>-->
          <!--<div v-if="error" class="alert alert-danger" role="alert">-->
            <!--<span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}-->
          <!--</div>-->
        <!--</b-col>-->
      <!--</b-row>-->
      <b-row>
        <b-col>
          <router-link :to="{ name: 'EXCMConsentList' }" class="btn btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXCMConsentForm
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMConsentForm from './Form'
import Loader from '../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('excmconsent/create')

export default {
  components: {
    EXCMConsentForm,
    Loader
  },

  data () {
    return {
      item: {}
    }
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      this.$Swal({
        title: created.title + ' ' + this.$t('notifications.created'),
        type: 'success',
        showConfirmButton: false,
        timer: 1500
      })
      this.$router.push({ name: 'EXCMConsentShow', params: { id: created['@id'] } })
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      let item = Object.assign({}, this.item)
      item.orderConsent = parseInt(item.orderConsent)
      this.create(item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
